
import styles from "./PartWorkItemUsed.module.scss";
import { useTranslation } from 'react-i18next'
import { useState } from "react";


import pieeeeechart from 'assets/icons/pieeeeechart.png'
import Notification from "utils/Notifications";

import { ChangeAnswer } from "service/TestService";
import { EditorState, convertFromRaw } from "draft-js";
import { Editor } from "react-draft-wysiwyg";

const PartWorkItemUse = ({ item, item_selected, item_selected_data, index, setRender }) => {
  const { t } = useTranslation('common')


    const [notify, setNotify] = useState({
        isOpen: false,
        message: "",
        type: "",
    });


    const DraftContent = ({ draftData }) => {
        let contentState;
        try {
            const parsedData = typeof draftData === "string" ? JSON.parse(draftData) : draftData;
            contentState = convertFromRaw(parsedData);
        } catch (error) {
            return <p>Invalid content format</p>;
        }

        const editorState = EditorState.createWithContent(contentState);

        return (
            <div st>
                <Editor editorState={editorState} readOnly toolbarHidden />
            </div>
        );
    };


    const numOptions = item.answer_part_worktest.length;
    return (


        <div className={styles.answer_card_selection}>
            {item.employee === item_selected.employee &&
                <>
                    {item.type_answer === 'singleSelection' && <h3>{t('surveyForm.single_selection')}</h3>}
                    {item.type_answer === 'multipleSelection' && <h3>{t('surveyForm.multiple_selection')}</h3>}
                    {item.type_answer === 'numericInput' && <h3>{t('surveyForm.numeric_input')}</h3>}
                    {item.type_answer === 'textInput' && <h3>{t('surveyForm.text_input')}</h3>}
                    {item.type_answer === 'freeTextAnswer' && <h3>{t('surveyForm.free_text_defendant')}</h3>}
                    {item.type_answer === 'sequenceOrdering' && <h3>{t('testForm.sequence_ordering')}</h3>}
                    {item.type_answer === 'slider' && <h3>{t('testForm.slider')}</h3>}
                    {item.type_answer === 'fileUpload' && <h3>{t('surveyForm.file_upload')}</h3>}
                    {item.type_answer === 'infoText' && <h3>{t('surveyForm.info_text')}</h3>}
                </>}
            {item.image &&
                <img
                    src={item.image}
                    className={styles.img_file}
                />
            }
            <div className={styles.answer_card_selection_body}>

                <h3 style={{ marginTop: "-16px" }}> <DraftContent draftData={item.body} /></h3>
                {((Number(item_selected) !== Number(item.id)) && item.type_answer !== "infoText") &&

                    <div className={styles.answer_card_selection_body_answer}>
                        {t('auto.components_partworkitemuse.k1')}
                    </div>
                }
                {Number(item_selected) === Number(item.id) &&
                    <>
                        <h4 style={{ display: 'flex', alignItems: 'start', justifyContent: 'start', width: "100%", flexDirection: "column" }}>

                            {t('auto.components_partsurveyitemuse.k2')}

                        </h4>
                        <div className={styles.answer_card_selection_body_answer}>
                            {item.answer_part_worktest.map((answer, index) => (
                                <>

                                    <div style={{ width: '100%' }}>
                                        {(item.type_answer !== "freeTextAnswer" && item.type_answer !== "infoText" && item.type_answer !== 'fileUpload') ? (
                                            <div className={styles.answer_card_header}>


                                                {(item.type_answer === 'sequenceOrdering') &&
                                                    <>
                                                        <DraftContent draftData={answer.title} />
                                                        <select
                                                            className={styles.point_check_num_text}
                                                            value={
                                                                item_selected_data
                                                                    .find(item => item.userusetestpart_employee_tests
                                                                        .some(test => test.answer === answer.id))?.userusetestpart_employee_tests
                                                                    .find(test => test.answer === answer.id)?.sequences_selectedNumber || ""
                                                            }

                                                        >
                                                            {


                                                                <option value={
                                                                    item_selected_data
                                                                        .find(item => item.userusetestpart_employee_tests
                                                                            .some(test => test.answer === answer.id))?.userusetestpart_employee_tests
                                                                        .find(test => test.answer === answer.id)?.sequences_selectedNumber || 1
                                                                }>{
                                                                        item_selected_data
                                                                            .find(item => item.userusetestpart_employee_tests
                                                                                .some(test => test.answer === answer.id))?.userusetestpart_employee_tests
                                                                            .find(test => test.answer === answer.id)?.sequences_selectedNumber || 1
                                                                    }</option>

                                                            }
                                                        </select>
                                                    </>
                                                }
                                                {(item.type_answer === 'slider') &&
                                                    <div style={{ display: 'flex', flexDirection: 'column', width: '100%', gap: "5px" }}>
                                                        <div>
                                                            <h4 >{answer.type_input_txt}</h4>

                                                        </div>
                                                        <div className={styles.slider_min_max}>

                                                            <input
                                                                id="slider"
                                                                type="range"
                                                                min={Math.min(Number(answer.min_len), Number(answer.max_len))}
                                                                max={Math.max(Number(answer.min_len), Number(answer.max_len))}
                                                                value={
                                                                    item_selected_data
                                                                        .find(item => item.userusetestpart_employee_tests
                                                                            .some(test => test.answer === answer.id))?.userusetestpart_employee_tests
                                                                        .find(test => test.answer === answer.id)?.ranswer || 0
                                                                }

                                                                style={{ width: '100%' }}
                                                            />
                                                            <span className={styles.slider_min_max_res}>
                                                                {
                                                                    item_selected_data
                                                                        .find(item => item.userusetestpart_employee_tests
                                                                            .some(test => test.answer === answer.id))?.userusetestpart_employee_tests
                                                                        .find(test => test.answer === answer.id)?.ranswer || ""
                                                                }
                                                            </span>

                                                        </div>
                                                    </div>
                                                }
                                                {(item.type_answer === 'numericInput') &&
                                                    <input
                                                        type="number"
                                                        value={
                                                            item_selected_data
                                                                .find(item => item.userusetestpart_employee_tests
                                                                    .some(test => test.answer === answer.id))?.userusetestpart_employee_tests
                                                                .find(test => test.answer === answer.id)?.type_input_int || ""
                                                        }

                                                        style={{ border: '1px solid rgb(41, 33, 33)', padding: '5px 10px', borderRadius: '6px', border: '0' }}
                                                        placeholder={t('auto.components_partsurveyitemused.k2')}
                                                    />
                                                }

                                                {(item.type_answer === 'textInput') &&
                                                    <input
                                                        type="text"
                                                        value={
                                                            item_selected_data
                                                                .find(item => item.userusetestpart_employee_tests
                                                                    .some(test => test.answer === answer.id))?.userusetestpart_employee_tests
                                                                .find(test => test.answer === answer.id)?.type_input_txt || ""
                                                        }

                                                        style={{ border: '1px solid rgb(123, 123, 123)', padding: '5px 10px', borderRadius: '6px', border: '0' }}
                                                        placeholder={t('tests.taking.enter_text')}
                                                    />
                                                }
                                                {(item.type_answer === 'singleSelection') &&
                                                    <>
                                                        <input
                                                            type="radio"
                                                            id={`answer-${answer.id}`}
                                                            checked={
                                                                item_selected_data
                                                                    .find(item => item.userusetestpart_employee_tests
                                                                        .some(test => test.answer === answer.id))?.userusetestpart_employee_tests
                                                                    .find(test => test.answer === answer.id)?.right_answer || false
                                                            }

                                                        />
                                                        <DraftContent draftData={answer.title} />
                                                    </>
                                                }
                                                {(item.type_answer === 'multipleSelection') &&
                                                    <>
                                                        <input
                                                            type="checkbox"
                                                            id={`answer-${answer.id}`}
                                                            checked={
                                                                item_selected_data
                                                                    .find(item => item.userusetestpart_employee_tests
                                                                        .some(test => test.answer === answer.id))?.userusetestpart_employee_tests
                                                                    .find(test => test.answer === answer.id)?.right_answer || false
                                                            }

                                                        />
                                                        <DraftContent draftData={answer.title} />
                                                    </>
                                                }

                                            </div>
                                        ) : (
                                            <>
                                                {item.type_answer === "freeTextAnswer" && (
                                                    <div className={styles.answer_card_header}>
                                                        <div className={styles.answer_card_second_div} >

                                                            {
                                                                item_selected_data
                                                                    .find(item => item.userusetestpart_employee_tests
                                                                        .some(test => test.answer === answer.id))?.userusetestpart_employee_tests
                                                                    .find(test => test.answer === answer.id)?.free_response || 'Файл не найден'
                                                            }


                                                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'end' }}>

                                                                

                                                                
                                                            </div>
                                                        </div>
                                                    </div>

                                                )}
                                                {item.type_answer === "fileUpload" && (
                                                    <div className={styles.answer_card_header}>
                                                        <div className={styles.answer_card_second_div} >

                                                            {t('auto.components_partsurveyitemuse.k3')}
                                                        </div>
                                                    </div>
                                                )}

                                            </>
                                        )}
                                        {answer.file &&
                                            <img
                                                src={answer.file}
                                                className={styles.img_file}
                                            />
                                        }
                                    </div>

                                </>
                            ))}

                        </div>
                    </>
                }
                 {item.comment ?
                    <div style={{ marginTop: '40px', display:'flex', flexDirection:'row', alignItems:'center', gap:'10px'}}>
                        
                        <DraftContent draftData={item.comment} />

                    </div> : null
                }
            </div>

            <hr></hr>
            <Notification notify={notify} setNotify={setNotify} />
        </div >


    );
};

export default PartWorkItemUse;
